export const SET_USERINFO = 'SET_USERINFO';
export const ADD_TAG = 'ADD_TAG';
export const REMOVE_TAG = 'REMOVE_TAG';
export const EMPTY_TAG = 'EMPTY_TAG';
export const SET_BREADCRUMB = 'SET_BREADCRUMB';
export const SET_TAGS = 'SET_TAGS';
export const SET_THEME = 'SET_THEME';
export const SET_COLLAPSE = 'SET_COLLAPSE';
export const SET_LOADING = 'SET_LOADING';
